/** Ignore terminal order frames older than this. Replays are not live fills or rejects. */
export const STALE_ORDER_NOTICE_MS = 3 * 60 * 1000;

/** Quiet window after LateJoin / EndSnapshot so a snapshot burst is not toasted. */
export const ORDER_NOTICE_QUIET_MS = 4000;

/**
 * After place-order HTTP already toasted a failure, ignore stream REJ toasts briefly
 * so the user does not see both "Order failed…" and "Order Rejected…".
 */
export const ORDER_REJECT_NOTICE_QUIET_MS = 8000;

const silentRejectOrderIds = new Set();
let suppressRejectNoticesUntil = 0;

/** Call when create-order HTTP already showed the failure banner. */
export function suppressOrderRejectNotices(result, now = Date.now()) {
  suppressRejectNoticesUntil = Math.max(
    suppressRejectNoticesUntil,
    now + ORDER_REJECT_NOTICE_QUIET_MS,
  );
  const orders = Array.isArray(result?.Orders) ? result.Orders : [];
  orders.forEach((order) => {
    const id = order?.OrderID;
    if (id != null && id !== '') silentRejectOrderIds.add(String(id));
  });
}

/** True when the stream should skip a REJ toast (HTTP path already notified). */
export function shouldSuppressOrderRejectNotice(orderId, now = Date.now()) {
  if (now < suppressRejectNoticesUntil) return true;
  if (orderId == null || orderId === '') return false;
  const key = String(orderId);
  if (!silentRejectOrderIds.has(key)) return false;
  silentRejectOrderIds.delete(key);
  return true;
}

/** Test helper — clear module-level reject suppress state. */
export function resetOrderRejectNoticeSuppress() {
  silentRejectOrderIds.clear();
  suppressRejectNoticesUntil = 0;
}

export function orderStatusEventAgeMs(order, now = Date.now()) {
  const raw = order?.ClosedDateTime || order?.OpenedDateTime || null;
  if (raw == null || raw === '') return null;
  const t = new Date(raw).getTime();
  if (!Number.isFinite(t)) return null;
  return now - t;
}

/**
 * In-app order toasts. A replay of an already-terminal order (filled, rejected,
 * cancelled) must not toast. The caller still requires a real status transition.
 */
export function shouldToastOrderStatus({ order, now = Date.now(), suppressUntil = 0 } = {}) {
  if (now < suppressUntil) return false;
  const age = orderStatusEventAgeMs(order, now);
  if (age != null && (age > STALE_ORDER_NOTICE_MS || age < -60_000)) return false;
  return true;
}
